import angular from 'angular';
import uiRouter from 'angular-ui-router';

import memberTabsComponent from 'member-tabs';
import memberDetailComponent from './member-detail.component';

const memberDetailModule = angular.module('memberDetail', [
  uiRouter,
])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $stateProvider
      .state('engineer.members.member-detail', {
        url: '/:memberId',
        template: '<member-detail member="$resolve.member" class="member-detail"></member-detail>',
        resolve: {
          member: (Member, $stateParams, $state) => {
            return Member.get({memberId: $stateParams.memberId}).$promise
              .then(response => new Member(response.member))
              .catch(reason => $state.go('engineer.members.member-list', { rejectReason: reason }));
          },
        }
      });
  })
  .component('memberTabs', memberTabsComponent)
  .component('memberDetail', memberDetailComponent);

export default memberDetailModule;



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/members/screens/member-detail/index.js